module.exports = __webpack_public_path__ + "static/media/30-14.0e8c1cc4.mp3";